import NotificationItemModule from './notification-item.module'

export default NotificationItemModule
